<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1 class="text">{{this.$route.meta.title}}</h1>
            </div>

            <div class="section-body">
                <div class="row">
                    <div class="col-12 text-center mt-3" v-if="no_data === null">
                        <div class="half-circle-spinner">
                            <div class="circle circle-1"></div>
                            <div class="circle circle-2"></div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === false">
                        <div class="card bdr-15" >
                            <div class="card-header border-0 pb-4 tb-card">
                                <div class="table-sorting">
                                    <div class="table-search float-left">
                                        <vue-search 
                                            :search="sorting"
                                            @searchdata="getWebsiteList()">
                                        </vue-search>
                                    </div>

                                    <div class="tabel-action float-right">
                                        <button type="submit" v-b-modal.modal-Website class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add Website</button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive bdr-15">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" id="all_id" v-model="selectAll">
                                                        <label class="custom-control-label" for="all_id"></label>
                                                    </div>
                                                </th>
                                                <th>Logo</th>
                                                <th>Name</th>
                                                <th>Agent</th>
                                                <th>Expired Date</th>
                                                <th>Status</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="tr-ac" v-for="data in website_list.data" :key="data.id" v-on:click="editWebsiteList(data)">
                                                <td width="100px" v-on:click.stop=""> 
                                                    <div class="custom-control custom-checkbox" v-if="data.id !== 1">
                                                        <input type="checkbox" class="custom-control-input" v-model="del_website" :value="data.id" :id="data.id">
                                                        <label class="custom-control-label" :for="data.id"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <img style="object-fit: contain !important" v-if="data.logo" class="mr-3 img-thum-product" :src="data.logo">
                                                    <img v-if="!data.logo" class="mr-3 img-thum-product" src="https://via.placeholder.com/150">
                                                </td>
                                                <td>
                                                    <div>{{data.name}}</div>
                                                    <div>{{data.domain}}</div>
                                                    <div><a :href="'https://' + data.domain" target="_blank"><i class="uil uil-link"></i> Visit</a></div>
                                                </td>
                                                <td>
                                                    <div>{{data.agent.name}}</div>
                                                    <div>{{data.agent.email}}</div>
                                                </td>
                                                <td>{{data.expired_date | formatDate}}</td>
                                                <td>
                                                    <label class="badge badge-success" v-if="data.is_active === 'true'">ACTIVE</label>
                                                    <label class="badge badge-warning" v-if="data.is_active === 'false'">DEACTIVE</label>
                                                </td>
                                                <td>
                                                    <button @click.prevent="detailWebsite(data.id)" class="btn btn-primary">Detail</button>
                                                </td>
                                            </tr>
                                        
                                        </tbody>
                                        
                                    </table>
                                    <p v-if="website_list.total === 0" class="text-center no-data">Website data not found</p>
                                </div>
                            </div>
                            <div class="card-footer">
                                <vue-pagination :pagination="website_list"
                                                :sorting="sorting"
                                                @paginate="getWebsite()">
                                </vue-pagination>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === true && sorting.search === ''">
                        <div class="card bdr-15">
                            <div class="card-body card-nitem text-center">
                                <img class="mb-5" src="@/assets/img/no-data.svg" alt="">
                                <div class="nitem-desc">
                                    <h2>Website Data Still Empty</h2>
                                    <p>On this page you can create website</p>
                                    <div class="tabel-action">
                                        <button type="submit" v-b-modal.modal-Website class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add Website</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-action" v-if="del_website.length !== 0">
                <div class="card-body">
                    <div class="float-left text-white mt-1">
                        <span v-on:click.prevent="del_website = []" class="times"><i class="uil uil-times"></i></span>
                        <span><span class="badge">{{del_website.length}}</span> website selected</span>
                    </div>
                    <div class="float-right">
                        <div v-on:click.prevent="alertDeleteWebsite()" class="btn btn-danger">
                            <i class="uil uil-times"></i> Delete
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <modal-form :del_website="del_website" @getWebsiteList="_getWebsiteList(),del_website = []"></modal-form>
    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'
    import VuePagination from "@/components/Pagination.vue";
    import VueSearch from "@/components/Search.vue";
    import ModalForm from '../website/ModalForm.vue'
    import moment from 'moment'


    export default {
        name: "Website",
        components: {
            VuePagination,
            VueSearch,
            ModalForm
        },
        data(){
            return {
                del_website:[],
                no_data: null,
            }
        },
        mounted(){
            this.title = this.$route.meta.title;
            this._getWebsiteList()
        },
        filters: {
            formatDate: function(val){
                if(val){
                    return moment(String(val)).format('DD MMMM YYYY')
                }else{
                    return '-'
                }
            },
        },
        computed:{
            ...mapState('WebsiteControl', {
                website_list: state => state.website_list,
                sorting: state => state.sorting
            }),
            selectAll: {
                get: function () {
                    return this.website_list.data ? this.del_website.length == this.website_list.data.length : false;
                },
                set: function (value) {
                    var selected = [];

                    if (value) {
                        this.website_list.data.forEach(function (website) {
                            if(website.id !== 1){
                                selected.push(website.id);
                            }
                        });
                    }
                    this.del_website = selected;
                }
            }
        },
        methods: {
            ...mapActions('WebsiteControl', ['getWebsiteList','deleteWebsiteList']),
            ...mapMutations('WebsiteControl', ['ASSIGN_FORM_WEBSITE_LIST']),
            
            detailWebsite:function(id){
                this.$router.push({ name: 'admin-detail-website', params: { id:id } })
            },
            _getWebsiteList:function(){
                this.getWebsiteList().then(() => {
                    if(this.website_list.total == 0){
                        this.no_data = true
                    }else{
                        this.no_data = false
                    }
                })
            },
            editWebsiteList:function(data){
                this.ASSIGN_FORM_WEBSITE_LIST(data)
                this.$bvModal.show('modal-Website')
            },
            alertDeleteWebsite:function(){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this website data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deleteWebsiteList(this.del_website).then(
                            this.$toast.success('Successfully Deleting Website'),
                            this.del_website = []
                        )
                    }
                })
            },
        },
    };

</script>
